/* autumn-promotion-lottery.js
 * Autumn Promotion Lottery — 抽奖组件 JS
 * 复用 m26-mystery-box.js 中的通用基础设施（M26Lottery / M26Modal / m26-login-guard 等），
 * 本文件只实现 autumn-promotion-lottery 特有逻辑：
 *   - 转盘图片点击 → 抽奖接口调用
 *   - 奖品列表：PC 端竖向滚动，Mobile 端 Swiper 轮播
 *   - 登录守卫：未登录时拦截并唤起 login-dialog，登录后刷新并滚动到组件
 *   - 弹框（Check the rules / My Winning Record）占位：仅打开空 modal，待后续接入
 */
(function () {
  "use strict";
  let M26ModalLocal = null;
  let M26LotteryLocal = null;
  let m26AuthLocal = null;
  let m26LoginLocal = null;
  /* 查找当前 section 注入的 activityType，兼容多实例 */
  function resolveActivityType(sectionId) {
    const norm = (sectionId || "").replace(/-/g, "_");
    const k1 = "__APL_ACTIVITY_TYPE_" + norm + "__";
    const k2 = "__APL_ACTIVITY_TYPE_" + norm;
    return window[k1] || window[k2] || window.__APL_ACTIVITY_TYPE__ || "";
  }

  /* ── 复用 m26 基础设施（m26Auth / M26Modal / M26Lottery 等） ── */
  function ensureM26Base() {
    if (
      window.__apl_base_ready__ &&
      M26ModalLocal &&
      M26LotteryLocal &&
      m26AuthLocal
    )
      return;
    window.__apl_base_ready__ = true;

    const hasGlobalModal = typeof M26Modal !== "undefined" ? M26Modal : null;
    const hasGlobalLottery =
      typeof M26Lottery !== "undefined" ? M26Lottery : null;
    const hasGlobalAuth = typeof m26Auth !== "undefined" ? m26Auth : null;
    const hasGlobalLogin = typeof m26Login !== "undefined" ? m26Login : null;

    if (hasGlobalModal && hasGlobalLottery && hasGlobalAuth) {
      M26ModalLocal = hasGlobalModal;
      M26LotteryLocal = hasGlobalLottery;
      m26AuthLocal = hasGlobalAuth;
      m26LoginLocal = hasGlobalLogin;
      return;
    }

    /* —— 以下为独立回退实现（m26-mystery-box.js 未加载时使用） —— */

    function getCookie(name) {
      const key = `${encodeURIComponent(name)}=`;
      const parts = document.cookie.split(";");
      for (let i = 0; i < parts.length; i++) {
        const p = parts[i].trim();
        if (p.indexOf(key) === 0)
          return decodeURIComponent(p.slice(key.length));
      }
      return null;
    }

    function parseJwt(token) {
      try {
        const payload = token.split(".")[1];
        if (!payload) return null;
        const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
        const pad = "=".repeat((4 - (base64.length % 4)) % 4);
        return JSON.parse(atob(base64 + pad));
      } catch (_) {
        return null;
      }
    }

    m26AuthLocal = { user: null, _cbs: [] };
    m26AuthLocal.onLogin = function (cb) {
      if (m26AuthLocal.user) {
        cb(m26AuthLocal.user);
        return;
      }
      m26AuthLocal._cbs.push(cb);
    };

    const cookieName =
      (window.__MC__CONFIG__ && window.__MC__CONFIG__.cookieName) ||
      "momcozy-token";
    const token = getCookie(cookieName);
    if (token) {
      const payload = parseJwt(token) || {};
      m26AuthLocal.user = {
        type: "cookie",
        token,
        email: payload.email || payload.sub || "",
      };
    }

    document.addEventListener("LUTE:AUTH:LOGIN", (e) => {
      m26AuthLocal.user = e.detail;
      m26AuthLocal._cbs.forEach((fn) => fn(m26AuthLocal.user));
      m26AuthLocal._cbs.length = 0;
    });
    document.addEventListener("LUTE:AUTH:LOGOUT", () => {
      m26AuthLocal.user = null;
    });

    m26LoginLocal = function () {
      const loginDialog = document.querySelector("login-dialog");
      if (loginDialog && typeof loginDialog.open === "function") {
        loginDialog.open(null, {
          activityType: `${window.__APL_ACTIVITY_TYPE__ || ""}`,
          mustAgreeEmail: true,
          redirect: window.location.href,
        });
      }
    };

    if (!customElements.get("m26-login-guard")) {
      class M26LoginGuard extends HTMLElement {
        connectedCallback() {
          this.addEventListener("click", this, true);
          const enterBtn = this.querySelector(".apl__enter-btn");
          const aplChance = this.querySelector(".apl__chances");
          if (enterBtn && aplChance) {
            //如果是有enterBtn则需要进行校验处理
            const auth = aplGetM26Auth();
            if (!(auth && auth.user)) {
              enterBtn.classList.add("apl__chance-enable");
              aplChance.classList.remove("apl__chance-enable");
            } else {
              enterBtn.classList.remove("apl__chance-enable");
              aplChance.classList.add("apl__chance-enable");
            }
          }
        }
        disconnectedCallback() {
          this.removeEventListener("click", this, true);
        }
        handleEvent(e) {
          if (e.type === "click") {
            aplSyncM26AuthFromCookie();
            const auth = aplGetM26Auth();
            if (!(auth && auth.user)) {
              e.stopPropagation();
              e.preventDefault();
              const app = this.closest("apl-app");
              if (app && typeof app._aplLogin === "function") {
                app._aplLogin();
              } else {
                if (m26LoginLocal) m26LoginLocal();
              }
            }
          }
        }
      }
      customElements.define("m26-login-guard", M26LoginGuard);
    }

    class _M26Modal {
      static _openCount = 0;
      static _overlayEl = null;
      static _syncStack() {
        const overlay = _M26Modal._overlayEl;
        if (!overlay) return;
        let topBox = null;
        for (let i = overlay.children.length - 1; i >= 0; i--) {
          const child = overlay.children[i];
          if (
            child &&
            child.classList &&
            child.classList.contains("m26-modal-box") &&
            child.classList.contains("is-open")
          ) {
            topBox = child;
            break;
          }
        }
        overlay.querySelectorAll(".m26-modal-box.is-open").forEach((box) => {
          if (box === topBox) {
            box.classList.remove("m26-modal-box--inactive");
            box.removeAttribute("aria-hidden");
          } else {
            box.classList.add("m26-modal-box--inactive");
            box.setAttribute("aria-hidden", "true");
          }
        });
      }
      static _getOverlay() {
        if (_M26Modal._overlayEl) return _M26Modal._overlayEl;
        const el = document.createElement("div");
        el.className = "m26-modal-overlay";
        el.addEventListener("click", (e) => {
          if (e.target !== el) return;
          for (let i = el.children.length - 1; i >= 0; i--) {
            const inst = el.children[i]._m26;
            if (inst && inst._isOpen) {
              inst.close();
              break;
            }
          }
        });
        document.body.appendChild(el);
        _M26Modal._overlayEl = el;
        return el;
      }
      constructor(className) {
        this._boxEl = null;
        this._bodyEl = null;
        this._triggerEl = null;
        this._closeTimer = null;
        this._isOpen = false;
        this._className = className || "";
      }
      setContent(html) {
        if (this._bodyEl) this._bodyEl.innerHTML = html;
        this._bodyHtml = html;
      }
      _ensureBox() {
        if (this._boxEl) return;
        const overlay = _M26Modal._getOverlay();
        const box = document.createElement("div");
        box.className = "m26-modal-box nt";
        box.setAttribute("role", "dialog");
        box.setAttribute("aria-modal", "true");
        box.innerHTML = `
          <button type="button" class="m26-modal__close" data-close aria-label="Close">
            <svg class="m26-modal__close-icon" aria-hidden="true">
              <use xlink:href="#lottery-modal-close"></use>
            </svg>
          </button>
          <div class="m26-modal__body"></div>`;
        box._m26 = this;
        box
          .querySelector("[data-close]")
          .addEventListener("click", () => this.close());
        overlay.appendChild(box);
        this._boxEl = box;
        this._bodyEl = box.querySelector(".m26-modal__body");
      }
      show() {
        this._triggerEl = document.activeElement;
        // 记录打开前的滚动位置，避免 overflow:hidden 切换 + focus 触发页面回顶
        this._scrollY = window.scrollY || window.pageYOffset || 0;
        this._ensureBox();
        const box = this._boxEl;
        if (box)
          box.className =
            "m26-modal-box nt" + (this._className ? " " + this._className : "");
        if (this._bodyHtml && this._bodyEl)
          this._bodyEl.innerHTML = this._bodyHtml;
        const overlay = _M26Modal._getOverlay();
        if (this._boxEl && this._boxEl.parentNode === overlay)
          overlay.appendChild(this._boxEl);
        requestAnimationFrame(() => {
          if (!this._boxEl || !this._bodyEl) return;
          overlay.classList.add("is-open");
          this._boxEl.classList.add("is-open");
          _M26Modal._openCount++;
          _M26Modal._syncStack();
          if (_M26Modal._openCount === 1)
            document.documentElement.classList.add("m26-scroll-lock");
          document.addEventListener(
            "keydown",
            this._handleKeydown || (() => {}),
          );
          this._isOpen = true;
        });
      }
      close() {
        if (!this._boxEl || !this._isOpen) return;
        this._isOpen = false;
        this._boxEl.classList.remove("is-open");
        _M26Modal._syncStack();
        setTimeout(() => {
          _M26Modal._openCount = Math.max(0, _M26Modal._openCount - 1);
          if (_M26Modal._openCount === 0) {
            // 关键修复：在 body 仍处于 overflow:hidden（class 未移除）时先完成
            // scrollTo，最后再解除滚动锁 + 隐藏 overlay。
            // 避免解除 overflow 状态的那一帧被浏览器强制跳顶（部分 iOS Safari /
            // Android WebView 对 overflow:hidden → '' 的瞬间会无视后续 scrollTo）。
            //
            // 注意：曾尝试在关闭时把焦点交还给 triggerEl（focus({preventScroll:true})），
            // 但部分移动端浏览器（iOS Safari / Android WebView）即使带 preventScroll 仍会
            // 触发滚动穿透 / 锁定页面导致后续无法滚动，所以这里彻底跳过 focus 调用，
            // 只保留 scrollTo(savedY) 来保证关闭后回到原滚动位置。
            const savedY = this._scrollY || 0;
            // 1) 在 body 还锁着时，scrollTo(savedY) 设置目标滚动位置
            try {
              window.scrollTo(0, savedY);
            } catch (_) {
              /* noop */
            }
            // 2) 最后才解锁 body + 移遮罩（用户感知到的是"已恢复"，不会先跳顶）
            document.documentElement.classList.remove("m26-scroll-lock");
            if (_M26Modal._overlayEl)
              _M26Modal._overlayEl.classList.remove("is-open");
            // unlock 之后再兜底一次 scrollTo，兼容某些浏览器在解锁后才真正接受滚动的场景
            try {
              window.scrollTo(0, savedY);
            } catch (_) {
              /* noop */
            }
          }
        }, 350);
      }
      destroy() {
        const pending = this._isOpen || this._closeTimer;
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
        this._isOpen = false;
        if (pending) {
          _M26Modal._openCount = Math.max(0, _M26Modal._openCount - 1);
          if (_M26Modal._openCount === 0) {
            document.documentElement.classList.remove("m26-scroll-lock");
            if (_M26Modal._overlayEl)
              _M26Modal._overlayEl.classList.remove("is-open");
          }
        }
        if (this._boxEl) {
          this._boxEl.remove();
          this._boxEl = null;
          this._bodyEl = null;
        }
        _M26Modal._syncStack();
      }
    }
    M26ModalLocal = _M26Modal;

    class _M26Lottery {
      static scrollToEl(el) {
        if (!el) return;
        const stickyEls = document.querySelectorAll(
          ".m26-nav.is-sticky, .m26-nav.is-fixed-top, [data-header-sticky]",
        );
        let offset = 0;
        stickyEls.forEach((s) => {
          offset += s.getBoundingClientRect().height;
        });
        const top =
          el.getBoundingClientRect().top + window.scrollY - offset - 20;
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      }
    }
    M26LotteryLocal = _M26Lottery;
  }

  ensureM26Base();

  /* ── 同步工具函数 ── */
  function aplGetCookie(name) {
    const key = `${encodeURIComponent(name)}=`;
    const parts = document.cookie.split(";");
    for (let i = 0; i < parts.length; i++) {
      const p = parts[i].trim();
      if (p.indexOf(key) === 0) return decodeURIComponent(p.slice(key.length));
    }
    return null;
  }
  function aplParseJwt(token) {
    try {
      const payload = token.split(".")[1];
      if (!payload) return null;
      const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
      const pad = "=".repeat((4 - (base64.length % 4)) % 4);
      return JSON.parse(atob(base64 + pad));
    } catch (_) {
      return null;
    }
  }
  function aplGetM26Auth() {
    if (m26AuthLocal) return m26AuthLocal;
    try {
      if (typeof m26Auth !== "undefined") return m26Auth;
    } catch (_) {}
    return null;
  }
  function aplSyncM26AuthFromCookie() {
    const auth = aplGetM26Auth();
    if (!auth) return;
    const cookieName =
      (window.__MC__CONFIG__ && window.__MC__CONFIG__.cookieName) ||
      "momcozy-token";
    const token = aplGetCookie(cookieName);
    if (!token) {
      auth.user = null;
      return;
    }
    if (auth.user && auth.user.token === token) return;
    const payload = aplParseJwt(token) || {};
    auth.user = {
      type: "cookie",
      token,
      email: payload.email || payload.sub || "",
    };
  }
  function aplApiBase() {
    return (
      (window.__MC__CONFIG__ && window.__MC__CONFIG__.apiUrl) ||
      "https://account.momcozy.com"
    );
  }
  //获取会员中心访问地址
  function aplAccountBase() {
    return (
      (window.__MC__CONFIG__ && window.__MC__CONFIG__.accountSiteUrl) ||
      "https://account.momcozy.com"
    );
  }

  function buildApiHeaders(extra) {
    aplSyncM26AuthFromCookie();
    const headers = {
      "Content-Type": "application/json",
    };
    if (window.__MC__CONFIG__ && window.__MC__CONFIG__.headers) {
      Object.keys(window.__MC__CONFIG__.headers).forEach((key) => {
        headers[key] = window.__MC__CONFIG__.headers[key];
      });
    }
    try {
      const config = window.__MC__CONFIG__;
      if (config && config.cookieName) {
        const token = aplGetCookie(config.cookieName);
        if (token) headers.Authorization = `Bearer ${token}`;
      }
    } catch (_) {
      /* noop */
    }
    if (extra) {
      Object.keys(extra).forEach((key) => {
        headers[key] = extra[key];
      });
    }
    return headers;
  }

  function aplQuery(params) {
    const search = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value === undefined || value === null || value === "") return;
      search.set(key, String(value));
    });
    return search.toString();
  }

  function aplUnwrapApiData(data) {
    if (data && data.code === "10001003") {
      const auth = aplGetM26Auth();
      if (auth) auth.user = null;
      document.dispatchEvent(new CustomEvent("lute:account:logout"));
      throw data;
    }
    if (!data || typeof data !== "object") return data;
    if (data.code && String(data.code) !== "200" && String(data.code) !== "0") {
      throw data;
    }
    if (Object.prototype.hasOwnProperty.call(data, "result"))
      return data.result;
    if (Object.prototype.hasOwnProperty.call(data, "data")) return data.data;
    return data;
  }

  async function aplApiGet(path, params) {
    const query = aplQuery(params);
    const url = aplApiBase() + path + (query ? "?" + query : "");
    const res = await fetch(url, {
      method: "GET",
      headers: buildApiHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw data;
    return aplUnwrapApiData(data);
  }

  async function aplApiGetWithMeta(path, params) {
    const query = aplQuery(params);
    const url = aplApiBase() + path + (query ? "?" + query : "");
    const res = await fetch(url, {
      method: "GET",
      headers: buildApiHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw data;
    const result = aplUnwrapApiData(data);
    if (result && typeof result === "object") {
      if (data && data.msg != null && result.msg == null) result.msg = data.msg;
      return result;
    }
    return {
      result,
      msg: data && data.msg != null ? data.msg : "",
    };
  }

  async function aplApiPostJson(path, body) {
    const res = await fetch(aplApiBase() + path, {
      method: "POST",
      headers: buildApiHeaders(),
      body: JSON.stringify(body || {}),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw data;
    return aplUnwrapApiData(data);
  }

  function aplApiMessage(data) {
    if (!data || typeof data !== "object") return "";
    return data.msg || data.message || data.errorMessage || data.error || "";
  }

  function aplChanceCount(data) {
    const raw =
      data &&
      typeof data === "object" &&
      Object.prototype.hasOwnProperty.call(data, "result")
        ? data.result
        : data;
    const count = Number(raw);
    return Number.isFinite(count) ? Math.max(0, count) : null;
  }

  function aplTruthy(value) {
    return value === true || value === "true" || value === 1 || value === "1";
  }

  function aplNormalizeId(value) {
    if (value == null) return "";
    return String(value).split("/").pop();
  }

  function aplProductGid(productId) {
    const id = String(productId || "").trim();
    if (!id) return "";
    return id.indexOf("gid://") === 0
      ? id
      : `gid://shopify/Product/${aplNormalizeId(id)}`;
  }

  function aplPrizeProductId(prize, fallback) {
    return aplNormalizeId(
      prize &&
        (prize.claimProductId ||
          prize.productId ||
          prize.shopifyProductId ||
          fallback),
    );
  }

  function aplImageFromVariant(variant) {
    if (!variant) return "";
    const image = variant.featured_image || variant.image || null;
    if (!image) return "";
    return typeof image === "string" ? image : image.src || image.url || "";
  }

  /* ── Mobile 端奖品列表 Swiper 初始化 ─────────────────────── */
  function restorePrizeList(prizesEl) {
    const list = prizesEl.querySelector(".apl__prize-list");
    if (!list) return;
    const slides = [...list.querySelectorAll(".apl__prize-slide")];
    slides.forEach((slide) => {
      [...slide.children].forEach((card) => list.insertBefore(card, slide));
      slide.remove();
    });
    if (list.classList.contains("swiper-wrapper")) {
      list.classList.remove("swiper-wrapper");
    }
    [...list.children].forEach((card) => {
      card.classList.remove("swiper-slide");
    });
  }

  function setPrizeCarouselMode(prizesEl, enabled) {
    const pool = prizesEl.closest(".apl__pool");
    if (!pool) return;
    pool.classList.toggle("apl__pool--prize-carousel", !!enabled);
  }

  function initPrizeSwiper(prizesEl) {
    if (typeof Swiper === "undefined") {
      setPrizeCarouselMode(prizesEl, false);
      return null;
    }
    const list = prizesEl.querySelector(".apl__prize-list");
    if (!list) {
      setPrizeCarouselMode(prizesEl, false);
      return null;
    }
    const cards = [...list.children];
    if (!cards.length) {
      setPrizeCarouselMode(prizesEl, false);
      return null;
    }

    /* Mobile 端：将奖品按每 6 个为一组打包到 swiper-slide 中（与 CSS 配合：每个 slide 内 2 列 × 3 行）
       奖品数 ≤ 6 时：使用静态 2 列布局，不启用 Swiper */
    if (cards.length <= 6) {
      /* 静态 2 列展示：不创建 swiper-slide 包装，依赖 CSS grid */
      if (list.classList.contains("swiper-wrapper")) {
        list.classList.remove("swiper-wrapper");
      }
      [...list.children].forEach((c) => {
        if (c.classList.contains("swiper-slide"))
          c.classList.remove("swiper-slide");
      });
      setPrizeCarouselMode(prizesEl, false);
      return null;
    }

    /* 奖品数 > 6：启用 Swiper，按 6 个一组打包 */
    if (!list.classList.contains("swiper-wrapper")) {
      list.classList.add("swiper-wrapper");
    }
    const perSlide = 6;
    const total = cards.length;
    const slidesNeeded = Math.ceil(total / perSlide);
    cards.forEach((card) => card.classList.remove("swiper-slide"));
    /* 重排：将卡片按 6 个一组放入新创建的 swiper-slide */
    [...list.children].forEach((c) => c.remove());
    for (let i = 0; i < slidesNeeded; i++) {
      const slide = document.createElement("li");
      slide.className = "apl__prize-slide swiper-slide";
      slide.setAttribute("role", "listitem");
      for (let j = 0; j < perSlide; j++) {
        const idx = i * perSlide + j;
        if (idx < total) slide.appendChild(cards[idx]);
      }
      list.appendChild(slide);
    }

    /* 销毁旧 swiper 实例（如有） */
    if (prizesEl._aplSwiper) {
      try {
        prizesEl._aplSwiper.destroy(true, true);
      } catch (_) {}
      prizesEl._aplSwiper = null;
    }

    const dotsEl = prizesEl.querySelector("[data-apl-dots]");
    prizesEl._aplSwiper = new Swiper(prizesEl, {
      slidesPerView: 1.2,
      spaceBetween: 7,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      pagination: dotsEl
        ? { el: dotsEl, clickable: true, type: "bullets" }
        : false,
      freeMode: false,
      grabCursor: true,
      watchOverflow: true,
    });
    setPrizeCarouselMode(prizesEl, true);
    // 强制所有奖品卡片等高（CSS 兜底之上的最终保险）。
    // 移动端卡片改为 absolute 定位后理论上 CSS 已足够，
    // 这里保留作为防御：等待所有图片加载完再规整，避免读到 0 高度。
    runAfterImagesLoaded(prizesEl, () => normalizePrizeCardHeights(prizesEl));
    return prizesEl._aplSwiper;
  }

  /* 移动端奖品卡片等高规整
   *
   * 关键修复（直接从 inline style 读取，而非 getComputedStyle）：
   *   旧问题：getComputedStyle(el).getPropertyValue('--foo') 对继承的 CSS 变量
   *   在部分浏览器 / 特定时机下可能返回空字符串（custom property 继承与计算时机
   *   的兼容差异），导致拿不到 schema 配置的卡片高度，函数直接 return。
   *
   *   新方案：直接读 .apl-section 元素上 inline style 属性（schema 通过 Liquid
   *   直接渲染在 style="" 上，是最可靠的数据源），用正则解析出 px 数值。
   *   拿不到时回退到 schema 默认值 135。 */
  var DEFAULT_PRIZE_CARD_H_MOBILE = 135;
  function normalizePrizeCardHeights(prizesEl) {
    if (!prizesEl) return;
    var cards = prizesEl.querySelectorAll(".apl__prize-card");
    if (!cards.length) return;

    /* 优先从最近 .apl-section 祖先的 inline style 中读取 --apl-prize-card-h-mb */
    var configured = 0;
    var sectionEl = prizesEl.closest(".apl-section");
    if (sectionEl && sectionEl.getAttribute("style")) {
      var m = sectionEl
        .getAttribute("style")
        .match(/--apl-prize-card-h-mb\s*:\s*([\d.]+)\s*px/);
      if (m && m[1]) configured = parseFloat(m[1]);
    }
    /* 回退：getComputedStyle（多数情况下也能拿到，作为兜底） */
    if (!configured) {
      var cssVar = window
        .getComputedStyle(sectionEl || prizesEl)
        .getPropertyValue("--apl-prize-card-h-mb");
      configured = parseFloat(cssVar);
    }
    /* 最终兜底默认值 */
    if (!configured || configured <= 0) configured = DEFAULT_PRIZE_CARD_H_MOBILE;

    /* 按与 CSS calc(... * 100vw / 375) 完全相同的公式计算 */
    var vw = window.innerWidth || 375;
    var cardH = configured * (vw / 375);
    if (!cardH || cardH < 50) return;

    var rounded = Math.round(cardH) + "px";
    cards.forEach(function (c) {
      c.style.setProperty("height", rounded, "important");
      c.style.setProperty("max-height", rounded, "important");
    });
  }

  /* 等所有图片加载完成后再调用回调，避免读到 0 高度 */
  function runAfterImagesLoaded(container, cb) {
    const imgs = container.querySelectorAll("img");
    if (!imgs.length) return cb();
    let remaining = imgs.length;
    const done = () => {
      remaining--;
      if (remaining <= 0) cb();
    };
    imgs.forEach((img) => {
      if (img.complete && img.naturalWidth > 0) {
        done();
      } else {
        img.addEventListener("load", done, { once: true });
        img.addEventListener("error", done, { once: true });
      }
    });
    // 兜底：5 秒后强制回调
    setTimeout(() => {
      if (remaining > 0) cb();
    }, 5000);
  }

  /* ── Rules 弹框自定义元素（apl-rules-panel） ───────────────────────
   * 与 26-pd-promotion-lottery.liquid 中 Rules 弹框的交互模式一致：
   *   - <apl-rules-panel> 包裹 <button> 触发器 + <template> 内容
   *   - 点击触发器 → 读取 template 内容 → 通过 M26Modal 弹框展示
   *   - 模板内的 HTML 由后台 rules_content（type: html）设置项控制
   * ─────────────────────────────────────────────────────────────────── */
  if (!customElements.get("apl-rules-panel")) {
    class AplRulesPanel extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this._modal = null;
        this.addEventListener("click", this);
      }
      disconnectedCallback() {
        this.removeEventListener("click", this);
      }
      handleEvent(e) {
        if (e.type !== "click") return;
        const trigger = e.target.closest("[data-apl-rules]");
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();
        // 唤起由 snippets/lottery-common-dialog.liquid 提供的公共弹框，
        // 通过 document 自定义事件 lottery-rules:open 触发；标签 与 aria-expanded 同步。
        const eventName = trigger.dataset.aplOpenEvent || "lottery-rules:open";
        trigger.setAttribute("aria-expanded", "true");
        document.dispatchEvent(
          new CustomEvent(eventName, { detail: { trigger } }),
        );
        setTimeout(() => {
          trigger.setAttribute("aria-expanded", "false");
        }, 400);
      }
    }
    customElements.define("apl-rules-panel", AplRulesPanel);
  }

  if (!window.__apl_rules_click_bound__) {
    window.__apl_rules_click_bound__ = true;
    document.addEventListener(
      "click",
      (e) => {
        // 兼容脱离 <apl-rules-panel> 容器的孤立 data-apl-rules 按钮
        const trigger = e.target.closest("[data-apl-rules]");
        if (!trigger) return;
        if (trigger.closest("apl-rules-panel")) return;
        e.preventDefault();
        e.stopPropagation();
        const eventName = trigger.dataset.aplOpenEvent || "lottery-rules:open";
        trigger.setAttribute("aria-expanded", "true");
        document.dispatchEvent(
          new CustomEvent(eventName, { detail: { trigger } }),
        );
        setTimeout(() => {
          trigger.setAttribute("aria-expanded", "false");
        }, 400);
      },
      true,
    );
  }

  /* ── AplApp 主自定义元素 ────────────────────────────────── */
  if (!customElements.get("apl-app")) {
    class AplApp extends HTMLElement {
      constructor() {
        super();
        this._drawing = false;
        this._recordModal = null;
        this._resultModal = null;
        this._recordItems = [];
        this._resizeRaf = 0;
        this._drawWheelModal = null;
        this._drawWheelState = null;
        this._drawWheelRaf = 0;
        this._onDocumentClick = this._handleDocumentClick.bind(this);
      }

      connectedCallback() {
        const sid = this.dataset.sectionId || "";
        this._activityType =
          this.dataset.activityType || resolveActivityType(sid);
        if (this._activityType)
          window.__APL_ACTIVITY_TYPE__ = this._activityType;

        this._bindDraw();
        this._bindActions();
        this._bindChancesUpdate();
        this._initLayout();
        this._checkHashScroll();
        this._bindResize();
        document.addEventListener("click", this._onDocumentClick);
        this._skuClaimedHandler = (e) => this._handleSkuClaimed(e);
        this._skuCloseHandler = (e) => this._handleSkuClose(e);
        this._skuErrorHandler = (e) => this._handleSkuError(e);
        document.addEventListener(
          "autumn-sku:claimed",
          this._skuClaimedHandler,
        );
        document.addEventListener("autumn-sku:close", this._skuCloseHandler);
        document.addEventListener("autumn-sku:error", this._skuErrorHandler);
      }

      disconnectedCallback() {
        if (this._prizeSwiper) {
          try {
            this._prizeSwiper.destroy(true, true);
          } catch (_) {}
          this._prizeSwiper = null;
        }
        if (this._onResize) {
          window.removeEventListener("resize", this._onResize);
          window.removeEventListener("orientationchange", this._onResize);
          if (window.visualViewport) {
            window.visualViewport.removeEventListener("resize", this._onResize);
          }
          this._onResize = null;
        }
        if (this._resizeRaf) {
          cancelAnimationFrame(this._resizeRaf);
          this._resizeRaf = 0;
        }
        if (this._wheelRO) {
          try {
            this._wheelRO.disconnect();
          } catch (_) {}
          this._wheelRO = null;
        }
        this._destroyDrawWheel();
        if (this._mqlMobile && this._mqlMobile.removeEventListener) {
          this._mqlMobile.removeEventListener("change", this._onBreakpoint);
          this._mqlMobile = null;
        }
        document.removeEventListener("click", this._onDocumentClick);
        if (this._skuConfirmHandler) {
          document.removeEventListener(
            "autumn-sku:confirm",
            this._skuConfirmHandler,
          );
          document.removeEventListener(
            "autumn-sku:claimed",
            this._skuClaimedHandler,
          );
          document.removeEventListener(
            "autumn-sku:close",
            this._skuCloseHandler,
          );
          document.removeEventListener(
            "autumn-sku:error",
            this._skuErrorHandler,
          );
          this._skuConfirmHandler = null;
          this._skuClaimedHandler = null;
          this._skuCloseHandler = null;
          this._skuErrorHandler = null;
        }
      }

      _initLayout() {
        if (typeof window.matchMedia !== "function") return;
        this._mqlMobile = window.matchMedia("(max-width: 768px)");
        this._onBreakpoint = () => this._syncLayoutMode();
        if (this._mqlMobile.addEventListener) {
          this._mqlMobile.addEventListener("change", this._onBreakpoint);
        } else if (this._mqlMobile.addListener) {
          this._mqlMobile.addListener(this._onBreakpoint);
        }
        this._syncLayoutMode();
      }

      _syncLayoutMode() {
        const prizesEl = this.querySelector("[data-apl-prizes]");
        if (!prizesEl) return;
        const isMobile = this._mqlMobile && this._mqlMobile.matches;
        if (isMobile) {
          this._prizeSwiper = initPrizeSwiper(prizesEl);
        } else {
          if (this._prizeSwiper) {
            try {
              this._prizeSwiper.destroy(true, true);
            } catch (_) {}
            this._prizeSwiper = null;
          }
          restorePrizeList(prizesEl);
          setPrizeCarouselMode(prizesEl, false);
        }
        this._matchPoolHeight();
      }

      /* PC 端：让奖池高度 = 转盘高度 */
      _matchPoolHeight() {
        const isMobile = this._mqlMobile && this._mqlMobile.matches;
        const pool = this.querySelector(".apl__pool");
        if (isMobile) {
          if (pool) pool.style.height = "";
          return;
        }
        const wheel = this.querySelector(".apl__wheel");
        if (!wheel || !pool) return;
        pool.style.height = wheel.getBoundingClientRect().height + "px";
      }

      _scheduleMatchPoolHeight() {
        if (this._resizeRaf) cancelAnimationFrame(this._resizeRaf);
        this._resizeRaf = requestAnimationFrame(() => {
          this._resizeRaf = requestAnimationFrame(() => {
            this._resizeRaf = 0;
            this._matchPoolHeight();
          });
        });
      }

      _bindResize() {
        this._onResize = () => this._scheduleMatchPoolHeight();
        window.addEventListener("resize", this._onResize, { passive: true });
        window.addEventListener("orientationchange", this._onResize, {
          passive: true,
        });
        if (window.visualViewport) {
          window.visualViewport.addEventListener("resize", this._onResize, {
            passive: true,
          });
        }
        this.querySelectorAll("img").forEach((img) => {
          if (!img.complete)
            img.addEventListener("load", this._onResize, { once: true });
        });
        if ("ResizeObserver" in window) {
          if (!this._wheelRO) {
            this._wheelRO = new ResizeObserver(() =>
              this._scheduleMatchPoolHeight(),
            );
            const wheel = this.querySelector(".apl__wheel");
            if (wheel) this._wheelRO.observe(wheel);
          }
        }
        this._scheduleMatchPoolHeight();
      }

      _bindDraw() {
        const btn = this.querySelector("[data-apl-draw]");
        if (btn) {
          btn.addEventListener("click", (e) => {
            e.stopPropagation();
            this._openDrawWheelModal();
          });
        }
      }

      _bindActions() {
        const recordBtn = this.querySelector("[data-apl-record]");
        if (recordBtn) {
          recordBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            aplSyncM26AuthFromCookie();
            const auth = aplGetM26Auth();
            if (!auth || !auth.user) {
              e.preventDefault();
              this._aplLogin();
              return;
            }
            this._openRecordModal();
          });
        }
        /* 统一登录拦截：捕获阶段拦截 */
        this._onLoginGuard = (e) => {
          if (e.target.closest(".m26-modal-overlay")) return;
          if (e.target.closest("[data-apl-rules]")) return;
          const isDraw = !!e.target.closest("[data-apl-draw]");
          const isRecord = !!e.target.closest("[data-apl-record]");
          if (!isDraw && !isRecord) return;
          aplSyncM26AuthFromCookie();
          const auth = aplGetM26Auth();
          if (!auth || !auth.user) {
            e.stopPropagation();
            e.preventDefault();
            this._aplLogin();
          }
        };
        this.addEventListener("click", this._onLoginGuard, true);
      }

      _bindChancesUpdate() {
        this._chanceStrong = this.querySelector(".apl__chances strong");
        this.addEventListener("m26:chances-updated", (e) => {
          this._updateChanceDisplay(e.detail.chances);
        });
        this._loadInitialChances();
      }

      _updateChanceDisplay(count) {
        if (!this._chanceStrong) return;
        this._chanceStrong.textContent = count;
      }

      async _handleDraw() {
        if (this._drawing) return;
        this._drawing = true;
        const btn = this.querySelector("[data-apl-draw]");
        const wheelBtn =
          this._drawWheelModal && this._drawWheelModal._boxEl
            ? this._drawWheelModal._boxEl.querySelector(
                "[data-apl-wheel-modal-action]",
              )
            : null;
        if (btn) {
          btn.disabled = true;
          btn.setAttribute("aria-busy", "true");
        }
        if (wheelBtn) this._setButtonLoading(wheelBtn, true);
        this._applyDrawWheelCloseState();
        try {
          aplSyncM26AuthFromCookie();
          const auth = aplGetM26Auth();
          if (!auth || !auth.user) {
            this._aplLogin();
            return;
          }
          //await this._checkRaffleStatus();
          //const chances = await this._refreshChances();
          // if (chances < 1) {
          //   this._showToast(this._t("noChancesToast"), "error");
          //   return;
          // }
          const rafflePromise = this._startRaffle();
          this._startDrawWheelSpin();
          const result = await rafflePromise;
          const refreshPromise = this._refreshChances().catch(() => null);
          await this._finishDrawWheelSpin(result);
          await refreshPromise;
          this._openResultModal(result);
        } catch (err) {
          this._cancelDrawWheelSpin();
          if (err && err.code === "10001003") {
            this._aplLogin();
          } else {
            this._showToast(
              aplApiMessage(err) || this._t("claimFailed"),
              "error",
            );
          }
        } finally {
          this._drawing = false;
          this._applyDrawWheelCloseState();
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute("aria-busy");
          }
          if (wheelBtn) this._setButtonLoading(wheelBtn, false);
        }
      }

      async _checkRaffleStatus() {
        return aplApiPostJson("/api/station/activity/raffle/checkStatus", {
          activityType: this._activityType || "",
        });
      }

      async _startRaffle() {
        return aplApiGet("/api/station/activity/raffle/startShopRaffleAuth", {
          newRaffleFlow: true,
          activityType: this._activityType || "",
        });
      }

      async _loadInitialChances() {
        try {
          const res = await aplApiGet(
            "/api/station/activity/raffle/queryRaffleNumber",
            {
              activityType: this._activityType || "",
            },
          );
          const count = aplChanceCount(res);
          if (count === null) return null;
          this._updateChanceDisplay(count);
          return count;
        } catch (_) {
          return null;
        }
      }

      async _refreshChances() {
        const res = await aplApiGet(
          "/api/station/activity/raffle/queryRaffleNumber",
          {
            activityType: this._activityType || "",
          },
        );
        const count = aplChanceCount(res) || 0;
        this._updateChanceDisplay(count);
        this.dispatchEvent(
          new CustomEvent("m26:chances-updated", {
            bubbles: true,
            detail: { chances: count },
          }),
        );
        return count;
      }

      _handleDocumentClick(e) {
        const target = e.target;
        const wheelAction = target.closest(
          `[data-apl-section="${this.dataset.sectionId}"][data-apl-wheel-modal-action]`,
        );
        if (wheelAction) {
          e.preventDefault();
          this._handleDraw();
          return;
        }
        const recordAction = target.closest(
          `[data-apl-section="${this.dataset.sectionId}"][data-apl-record-action]`,
        );
        if (recordAction) {
          e.preventDefault();
          this._handleRecordAction(recordAction);
          return;
        }
        const resultAction = target.closest(
          `[data-apl-section="${this.dataset.sectionId}"][data-apl-result-action]`,
        );
        if (resultAction) {
          e.preventDefault();
          this._handleResultAction(resultAction);
          return;
        }
        const optionBtn = target.closest(
          `[data-apl-section="${this.dataset.sectionId}"][data-apl-option-value]`,
        );
        if (optionBtn) {
          // 多 SKU 选择交互已抽到 lottery-common-sku 组件，事件由组件内部处理
          return;
        }
        const variantAction = target.closest(
          `[data-apl-section="${this.dataset.sectionId}"][data-apl-variant-action]`,
        );
        if (variantAction) {
          // confirm / cancel 交互已抽到 lottery-common-sku 组件，事件由组件内部处理
          return;
        }
      }

      _t(key) {
        const i18n =
          (window.__APL_I18N__ &&
            window.__APL_I18N__[this.dataset.sectionId]) ||
          {};
        const defaults = {
          sorry: "Sorry",
          congratulations: "Congratulations!",
          losingTitle: "Better Luck Next Time!",
          noChancesTitle: "0 chances to Lucky Spin!",
          noStartTitle: "Lucky Spin has not started yet!",
          noChancesToast: "No draw chances left.",
          extraChanceTitle: "You got a extra chance!",
          claimNow: "Claim Now",
          selectYourPrize: "Select Your Prize",
          ok: "OK",
          goTakePart: "Go to Take Part",
          copy: "Copy",
          copied: "Copied",
          drawPlayNow: "Play Now",
          recordTitle: "My Winning Record",
          loading: "Loading...",
          noWinningRecords:
            "You haven't drawn any prizes yet.\nTry your luck today!",
          edit: "Edit",
          claim: "Claim",
          claimed: "Claimed",
          recordOrderName: "Order Number",
          contactMomcozy: "Contact Momcozy >",
          am: "AM",
          pm: "PM",
          claimSuccess: "Claimed successfully.",
          claimFailed: "Claim failed.",
          switchSpecs: "Switch Specs",
          cancel: "Cancel",
          confirm: "Confirm",
          defaultLoseDesc: "Thank You for Participating",
          defaultNoChancesDesc: "Thank You for Participating",
          defaultExtraChanceDesc: "Try Again",
          defaultPrizeDesc: "Select your preferred model and claim your prize.",
          specialLoseDesc:
            "Sorry, you did not win a prize. Please try again next time.",
          couponValidDesc:
            "Valid within 30 days.\ncheck out your prize in My Winning Record",
          normalCouponValidDesc:
            "Valid through October 31, 2026.\ncheck out your prize in My Winning Record",
          coinsDesc: "You've won 100 CozyCoins!",
          outOfStock: "Out of Stock",
          goToMemberCenter: "Account>CozyCoins",
          goToGiftCardCenter: "Account>Coupons",
        };
        const value = i18n[key];
        if (typeof value === "string") {
          return /^translation missing:/i.test(value.trim())
            ? defaults[key] || ""
            : value;
        }
        return value || defaults[key] || "";
      }

      /* 通过奖品等级匹配 card：prizeInfo.result >= 0 时按 prize_level 匹配；
         同时保留 productId 兜底匹配（实物奖品 SKU 流程需要）。 */
      _getPrizeMeta(prize) {
        const productId = aplPrizeProductId(prize);
        const result = Number(prize && prize.result);
        const cards = [...this.querySelectorAll(".apl__prize-card")];
        const card = cards.find((item) => {
          if (
            Number.isFinite(result) &&
            result >= 0 &&
            Number(item.dataset.prizeLevel) === result
          ) {
            return true;
          }
          if (productId) {
            const itemProductId = aplNormalizeId(item.dataset.productId);
            return itemProductId && itemProductId === productId;
          }
          return false;
        });
        const img = card && card.querySelector("img");
        return {
          card,
          productId,
          result,
          name: card ? card.dataset.prizeName || "" : "",
          desc: card ? card.dataset.prizeDesc || "" : "",
          image: img ? img.currentSrc || img.src || "" : "",
          productHandle: card ? card.dataset.productHandle || "" : "",
        };
      }

      _wheelModalImage() {
        if (this.dataset.wheelModalImage) return this.dataset.wheelModalImage;
        const img = this.querySelector(".apl__wheel-img");
        return img ? img.currentSrc || img.src || "" : "";
      }

      _drawWheelNumberConfig(name, fallback, min) {
        const value = Number(this.dataset[name]);
        if (!Number.isFinite(value)) return fallback;
        return typeof min === "number" ? Math.max(min, value) : value;
      }

      async _openDrawWheelModal() {
        aplSyncM26AuthFromCookie();
        const auth = aplGetM26Auth();
        if (!auth || !auth.user) {
          this._aplLogin();
          return;
        } else {
          //进行checkStatus校验
          try {
            await this._checkRaffleStatus();
            const chances = await this._refreshChances();
            if (chances < 1) {
              this._openResultModal({
                result: -2,
              });
              return;
            }
            if (!M26ModalLocal) ensureM26Base();
            if (!M26ModalLocal) return;
            if (!this._drawWheelModal) {
              this._drawWheelModal = new M26ModalLocal(
                "apl-modal apl-modal--draw-wheel",
              );
              const originalClose = this._drawWheelModal.close.bind(
                this._drawWheelModal,
              );
              this._drawWheelModal.close = () => {
                if (this._shouldBlockDrawWheelClose()) {
                  this._applyDrawWheelCloseState();
                  return;
                }
                this._cancelDrawWheelSpin();
                originalClose();
                setTimeout(() => this._setDrawWheelOverlay(false), 360);
              };
            }
            this._drawWheelModal.setContent(this._renderDrawWheelModal());
            this._drawWheelModal.show();
            this._setDrawWheelOverlay(true);
            requestAnimationFrame(() => {
              this._initDrawWheelCanvas();
              this._applyDrawWheelCloseState();
            });
          } catch (error) {
            const { message } = error;
            this._openResultModal({
              result: -3,
              subTitle: this._t("sorry"),
              title: message || this._t("noStartTitle"),
            });
          }
        }
      }

      _renderDrawWheelModal() {
        const sid = this._esc(this.dataset.sectionId || "");
        const hasPointerImage = !!this.dataset.wheelPointerImage;
        const showText = this.dataset.showDrawPointerText !== "false";
        const pointerStyle = this.dataset.wheelPointerImage
          ? ` style="--apl-draw-pointer-bg:url('${this._esc(this.dataset.wheelPointerImage)}')"`
          : "";
        return `<div class="apl-draw-wheel"><div class="apl-draw-wheel__stage"><canvas class="apl-draw-wheel__canvas" data-apl-draw-wheel-canvas aria-hidden="true"></canvas><button type="button" class="apl-draw-wheel__pointer${hasPointerImage ? " has-pointer-image" : ""}${showText ? "" : " is-text-hidden"}" data-apl-section="${sid}" data-apl-wheel-modal-action="start"${pointerStyle}><span>${showText ? this._esc(this._t("drawPlayNow")) : ""}</span></button></div></div>`;
      }

      _setDrawWheelOverlay(active) {
        const overlay = document.querySelector(".m26-modal-overlay");
        if (!overlay) return;
        overlay.classList.toggle("apl-wheel-overlay", !!active);
        if (active) {
          const opacity = Number(this.dataset.wheelOverlayOpacity || 0.35);
          overlay.style.setProperty(
            "--apl-wheel-overlay-opacity",
            String(Number.isFinite(opacity) ? opacity : 0.35),
          );
        } else {
          overlay.style.removeProperty("--apl-wheel-overlay-opacity");
        }
      }

      _shouldBlockDrawWheelClose() {
        return (
          this._drawing ||
          this._isModalOpen(this._resultModal) ||
          this._isSkuModalOpen()
        );
      }

      _isSkuModalOpen() {
        const el = document.querySelector(
          'apl-lottery-sku[data-sku-id="autumn-sku"]',
        );
        if (!el || !el._overlay) return false;
        return el._overlay.classList.contains("is-open");
      }

      _isModalOpen(modal) {
        return !!(
          modal &&
          (modal._isOpen ||
            (modal._boxEl && modal._boxEl.classList.contains("is-open")))
        );
      }

      _refreshDrawWheelCloseAfterModalClose(modal) {
        if (!modal || modal._aplRefreshDrawWheelClose) return;
        const originalClose = modal.close.bind(modal);
        modal.close = (...args) => {
          const result = originalClose(...args);
          setTimeout(() => this._applyDrawWheelCloseState(), 360);
          return result;
        };
        modal._aplRefreshDrawWheelClose = true;
      }

      _applyDrawWheelCloseState() {
        if (!this._drawWheelModal || !this._drawWheelModal._boxEl) return;
        const locked = this._shouldBlockDrawWheelClose();
        this._drawWheelModal._boxEl.classList.toggle(
          "apl-modal--locked",
          locked,
        );
        const closeBtn =
          this._drawWheelModal._boxEl.querySelector("[data-close]");
        if (closeBtn) {
          closeBtn.disabled = locked;
          closeBtn.setAttribute("aria-disabled", locked ? "true" : "false");
        }
      }

      _initDrawWheelCanvas() {
        if (!this._drawWheelModal || !this._drawWheelModal._boxEl) return null;
        const canvas = this._drawWheelModal._boxEl.querySelector(
          "[data-apl-draw-wheel-canvas]",
        );
        const src = this._wheelModalImage();
        if (!canvas || !src) return null;
        if (
          this._drawWheelState &&
          this._drawWheelState.canvas === canvas &&
          this._drawWheelState.src === src
        ) {
          this._drawDrawWheel();
          return this._drawWheelState;
        }
        const image = new Image();
        image.decoding = "async";
        image.onload = () => {
          if (!this._drawWheelState || this._drawWheelState.image !== image)
            return;
          this._drawWheelState.loaded = true;
          this._drawDrawWheel();
        };
        this._drawWheelState = {
          canvas,
          ctx: canvas.getContext("2d"),
          image,
          src,
          loaded: false,
          angle: 0,
          velocity: 0,
          spinning: false,
          stopping: false,
          spinStart: 0,
          lastFrameTime: 0,
        };
        image.src = src;
        return this._drawWheelState;
      }

      _drawDrawWheel() {
        const state = this._drawWheelState || this._initDrawWheelCanvas();
        if (!state || !state.ctx || !state.loaded) return;
        const rect = state.canvas.getBoundingClientRect();
        const dpr = Math.max(1, window.devicePixelRatio || 1);
        const size = Math.max(
          1,
          Math.round(
            Math.min(rect.width || 600, rect.height || rect.width || 600) * dpr,
          ),
        );
        if (state.canvas.width !== size || state.canvas.height !== size) {
          state.canvas.width = size;
          state.canvas.height = size;
        }
        const ctx = state.ctx;
        ctx.clearRect(0, 0, size, size);
        ctx.save();
        ctx.translate(size / 2, size / 2);
        ctx.rotate((state.angle * Math.PI) / 180);
        const ratio = Math.min(
          size / state.image.naturalWidth,
          size / state.image.naturalHeight,
        );
        const width = state.image.naturalWidth * ratio;
        const height = state.image.naturalHeight * ratio;
        ctx.drawImage(state.image, -width / 2, -height / 2, width, height);
        ctx.restore();
      }

      _drawWheelFrame(time) {
        const state = this._drawWheelState;
        if (!state) return;
        if (state.stopping) {
          const progress = Math.min(
            1,
            (time - state.stopStart) / state.stopDuration,
          );
          const distance = state.stopTo - state.stopFrom;
          const duration = state.stopDuration / 1000;
          const initialSlope =
            (state.stopVelocity || distance / duration) * duration;
          const progress2 = progress * progress;
          const progress3 = progress2 * progress;
          const easedDistance =
            initialSlope * progress +
            (3 * distance - 2 * initialSlope) * progress2 +
            (initialSlope - 2 * distance) * progress3;
          state.angle = state.stopFrom + easedDistance;
          this._drawDrawWheel();
          if (progress >= 1) {
            state.angle = ((state.stopTo % 360) + 360) % 360;
            state.velocity = 0;
            state.spinning = false;
            state.stopping = false;
            this._drawWheelRaf = 0;
            this._drawDrawWheel();
            if (state.stopResolve) state.stopResolve();
            state.stopResolve = null;
            return;
          }
        } else if (state.spinning) {
          const elapsed = Math.max(0, time - state.spinStart);
          const delta = state.lastFrameTime
            ? Math.min(64, time - state.lastFrameTime) / 1000
            : 1 / 60;
          const baseSpeed = this._drawWheelNumberConfig(
            "drawSpinBaseSpeed",
            84,
            1,
          );
          const maxSpeed = this._drawWheelNumberConfig(
            "drawSpinMaxSpeed",
            864,
            baseSpeed,
          );
          const rampDuration = this._drawWheelNumberConfig(
            "drawSpinRampDuration",
            900,
            1,
          );
          const speed =
            baseSpeed +
            (maxSpeed - baseSpeed) * Math.min(1, elapsed / rampDuration) ** 2;
          state.velocity = speed;
          state.angle += state.velocity * delta;
          this._drawDrawWheel();
        }
        state.lastFrameTime = time;
        if (state.spinning || state.stopping) {
          this._drawWheelRaf = requestAnimationFrame((nextTime) =>
            this._drawWheelFrame(nextTime),
          );
        } else {
          this._drawWheelRaf = 0;
        }
      }

      _startDrawWheelSpin() {
        const state = this._initDrawWheelCanvas();
        if (!state) return;
        state.spinning = true;
        state.stopping = false;
        state.spinStart = performance.now();
        state.lastFrameTime = 0;
        state.velocity = this._drawWheelNumberConfig(
          "drawSpinBaseSpeed",
          84,
          1,
        );
        if (!this._drawWheelRaf) {
          this._drawWheelRaf = requestAnimationFrame((time) =>
            this._drawWheelFrame(time),
          );
        }
      }

      _finishDrawWheelSpin(rawPrize) {
        const state = this._initDrawWheelCanvas();
        if (!state) return new Promise((resolve) => setTimeout(resolve, 1500));
        const cards = [...this.querySelectorAll(".apl__prize-card")];
        const count = cards.length || 1;
        const index = this._drawWheelPrizeIndex(rawPrize, cards);
        const sector = 360 / count;
        const result =
          rawPrize && typeof rawPrize === "object"
            ? Number(rawPrize.result)
            : Number(rawPrize);
        const losingBoundaryCorrection = Math.min(4, sector * 0.08);
        const alignedAngle =
          Number.isFinite(result) && result < 0
            ? sector / 2 + losingBoundaryCorrection
            : -index * sector;
        let target = alignedAngle;
        while (target <= state.angle) target += 360;
        const stopDuration = this._drawWheelNumberConfig(
          "drawStopDuration",
          1500,
          300,
        );
        const minTurns = this._drawWheelNumberConfig("drawStopMinTurns", 2, 1);
        const currentSpeed = Math.max(360, Math.abs(state.velocity || 720));
        const preferredDistance = Math.max(
          360 * minTurns,
          currentSpeed * (stopDuration / 1000) * 0.8,
        );
        while (target < state.angle + preferredDistance) target += 360;
        state.spinning = true;
        state.stopping = true;
        state.stopStart = performance.now();
        state.stopDuration = stopDuration;
        state.stopFrom = state.angle;
        state.stopTo = target;
        state.stopVelocity = Math.max(360, state.velocity || 720);
        state.lastFrameTime = 0;
        return new Promise((resolve) => {
          state.stopResolve = resolve;
          if (!this._drawWheelRaf) {
            this._drawWheelRaf = requestAnimationFrame((time) =>
              this._drawWheelFrame(time),
            );
          }
        });
      }

      /* 按 prizeInfo.result（>=0）→ block.prize_level 找到对应奖品在 cards 中的索引。
         顺时针顺序已在 liquid 模板中固定（blocks 顺序即转盘指针顺时针）。
         result < 0 时返回 0（停在第一个 block），保持原有行为。 */
      _drawWheelPrizeIndex(rawPrize, cards) {
        const prize = rawPrize && typeof rawPrize === "object" ? rawPrize : {};
        const result = Number(prize.result);
        if (Number.isFinite(result) && result >= 0) {
          const index = cards.findIndex(
            (card) => Number(card.dataset.prizeLevel) === result,
          );
          if (index >= 0) return index;
        }
        /* 兜底：优先按 productId 匹配（实物奖品 SKU 弹框流程需要）
           —— 仅在 prize.prizeLevel 没匹配上时使用。 */
        const productId = aplPrizeProductId(prize);
        if (productId) {
          const index = cards.findIndex(
            (card) => aplNormalizeId(card.dataset.productId) === productId,
          );
          if (index >= 0) return index;
        }
        return 0;
      }

      _cancelDrawWheelSpin() {
        if (this._drawWheelRaf) {
          cancelAnimationFrame(this._drawWheelRaf);
          this._drawWheelRaf = 0;
        }
        if (this._drawWheelState) {
          this._drawWheelState.spinning = false;
          this._drawWheelState.stopping = false;
          if (this._drawWheelState.stopResolve)
            this._drawWheelState.stopResolve();
          this._drawWheelState.stopResolve = null;
        }
      }

      _destroyDrawWheel() {
        this._cancelDrawWheelSpin();
        this._drawWheelState = null;
        this._drawWheelModal = null;
        this._setDrawWheelOverlay(false);
      }

      _normalizePrize(raw) {
        const prize = raw && typeof raw === "object" ? raw : { result: raw };
        const result = Number(prize.result);
        const prizeType = Number(prize.prizeType || prize.type || 0);
        const meta = this._getPrizeMeta(prize);
        const isNegativeResult = Number.isFinite(result) && result < 0;
        const image =
          prize.prizeImg ||
          prize.prizeUrl ||
          (!isNegativeResult && meta.image) ||
          (isNegativeResult ? this.dataset.fallbackLosingImage : "") ||
          this.dataset.fallbackPrizeImage ||
          meta.image ||
          "";
        const name = prize.prizeName || meta.name || prize.name || "";
        const isSpecialLoseMsg =
          result === -1 && String(prize.msg || "") === "3";
        let desc = isSpecialLoseMsg
          ? this._t("specialLoseDesc")
          : prize.prizeDesc || meta.desc || "";
        if (!desc) {
          if (result === -2) desc = this._t("defaultNoChancesDesc");
          else if (isNegativeResult) desc = this._t("defaultLoseDesc");
          else if (prizeType === 8) desc = this._t("defaultExtraChanceDesc");
          else if (prizeType === 5) desc = this._t("couponValidDesc");
          else if (prizeType === 3 || prizeType === 7)
            desc = this._t("normalCouponValidDesc");
          else if (prizeType === 2) desc = this._t("coinsDesc");
          else if (prizeType === 1) desc = this._t("defaultPrizeDesc");
          else desc = this._t("defaultPrizeDesc");
        }
        return {
          raw: prize,
          result,
          prizeType,
          needSelectVariant: aplTruthy(
            prize.needSelectVariant == null
              ? prize.multiVariant
              : prize.needSelectVariant,
          ),
          productId: aplPrizeProductId(prize, meta.productId),
          productHandle:
            prize.productHandle || prize.handle || meta.productHandle || "",
          activityUserPrizeCode:
            prize.activityUserPrizeCode ||
            prize.userPrizeCode ||
            prize.prizeCode ||
            "",
          claimVariantId: aplNormalizeId(
            prize.claimVariantId || prize.variantId || prize.defaultVariantId,
          ),
          couponCode: prize.couponCode || prize.code || prize.prizeCode || "",
          image,
          name,
          desc,
          isSpecialLoseMsg,
          title: prize.title || "",
          subTitle: prize.subTitle || "",
        };
      }

      _resultTitle(prize) {
        if (prize.result === -3) return prize.title || this._t("noStartTitle");
        if (prize.result === -2) return this._t("noChancesTitle");
        if (Number.isFinite(prize.result) && prize.result < 0)
          return this._t("losingTitle");
        if (prize.prizeType === 8) return this._t("extraChanceTitle");
        return this._t("congratulations");
      }

      _resultAction(prize) {
        if (Number.isFinite(prize.result) && prize.result < 0) return "ok";
        if (prize.prizeType === 8) return "extra";
        if (prize.prizeType === 3 || prize.prizeType === 7) return "copy";
        if (prize.prizeType === 1 && prize.needSelectVariant) return "variant";
        return "claim";
      }

      _openResultModal(rawPrize) {
        if (!M26ModalLocal) return;
        const prize = this._normalizePrize(rawPrize);
        this._currentPrize = prize;
        if (!this._resultModal)
          this._resultModal = new M26ModalLocal("apl-modal apl-modal--result");
        this._refreshDrawWheelCloseAfterModalClose(this._resultModal);
        this._resultModal.setContent(this._renderResultModal(prize));
        if (this._currentPrize.isSpecialLoseMsg) {
          //如果是特殊情况则toast提示，否则则展示弹框
          this._showToast(prize.desc, "error");
        } else {
          this._resultModal.show();
        }
        this._applyDrawWheelCloseState();
        requestAnimationFrame(() => this._applyDrawWheelCloseState());
      }

      _renderResultModal(prize) {
        const sid = this._esc(this.dataset.sectionId || "");
        const action = this._resultAction(prize);
        const title = this._esc(this._resultTitle(prize));
        const imageHtml = prize.image
          ? `<img class="apl-result__image" src="${this._esc(prize.image)}" alt="${this._esc(prize.name)}" loading="lazy">`
          : "";
        const showPrizeName =
          this.dataset.showResultPrizeName !== "false" && prize.result != -3;
        const nameHtml =
          showPrizeName && prize.name
            ? `<h3 class="apl-result__name">${this._esc(prize.name)}</h3>`
            : "";
        const descHtml =
          prize.desc && prize.result != -3
            ? `<p class="apl-result__desc">${this._esc(prize.desc).replace(/\n/g, "<br>")}</p>`
            : "";
        let footer = "";
        if (action === "copy") {
          footer = `<div class="apl-result__coupon"><span>${this._esc(prize.couponCode)}</span><button type="button" class="apl-result__btn" data-apl-section="${sid}" data-apl-result-action="copy">${this._esc(this._t("copy"))}</button></div>`;
        } else {
          const label =
            action === "variant"
              ? this._t("selectYourPrize")
              : action === "ok"
                ? this._t("ok")
                : action === "extra"
                  ? this._t("goTakePart")
                  : this._t("claimNow");
          footer = `<button type="button" class="apl-result__btn" data-apl-section="${sid}" data-apl-result-action="${action}"><span>${this._esc(label)}</span></button>`;
        }
        return `<div class="apl-result ${prize.result === -3 ? "apl-result--no-start" : ""}">${prize.result === -3 ? `<div class="apl-result__sub-title">${prize.subTitle}</div>` : ""}<h2 class="apl-result__title">${title}</h2><div class="apl-result__media">${imageHtml}</div>${nameHtml}${descHtml}<div class="apl-result__footer">${footer}</div></div>`;
      }

      async _handleResultAction(button) {
        const action = button.dataset.aplResultAction;
        const prize = this._currentPrize;
        if (!prize) return;
        if (action === "ok") {
          this._closeModal(this._resultModal);
          return;
        }
        if (action === "extra") {
          this._closeModal(this._resultModal);
          this._showToast(this._t("claimSuccess"), "success");
          return;
        }
        if (action === "copy") {
          await this._copyCoupon(prize.couponCode, button);
          return;
        }
        if (action === "variant") {
          this._openVariantModal(prize, button, this._resultModal);
          return;
        }
        if (action === "claim") {
          await this._claimPrize(prize, button);
        }
      }

      async _claimPrize(prize, button) {
        if (prize.prizeType !== 1) {
          this._setButtonLoading(button, true);
          setTimeout(() => {
            this._setButtonLoading(button, false);
            this._closeModal(this._resultModal);
            this._closeModal(this._recordModal);
            this._showToast(
              aplApiMessage(prize.raw) || this._t("claimSuccess"),
              "success",
            );
          }, 150);
          return;
        }
        this._setButtonLoading(button, true);
        try {
          const res = await aplApiGet(
            "/api/station/activity/raffle/queryClaimParams",
            {
              activityType: this._activityType || "",
              activityUserPrizeCode: prize.activityUserPrizeCode,
            },
          );
          const checkoutUrl = res && (res.checkoutUrl || res.url);
          if (checkoutUrl) {
            this._closeModal(this._recordModal);
            window.location.href = checkoutUrl;
            this._closeModal(this._resultModal);
            this._closeModal(this._recordModal);
            // this._showToast(
            //   aplApiMessage(res) || this._t("claimSuccess"),
            //   "success",
            // );
          } else {
            //如果是没有checkoutUrl的情况，直接提示领取失败
            this._showToast(
              aplApiMessage(res) || this._t("claimFailed"),
              "error",
            );
          }
        } catch (err) {
          this._showToast(
            aplApiMessage(err) || this._t("claimFailed"),
            "error",
          );
        } finally {
          this._setButtonLoading(button, false);
        }
      }

      async _copyCoupon(code, button) {
        if (!code) return;
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(code);
          } else {
            const input = document.createElement("textarea");
            input.value = code;
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            input.remove();
          }
          button.textContent = this._t("copied");
          this._showToast(this._t("copied"), "success");
        } catch (err) {
          this._showToast(this._t("claimFailed"), "error");
        }
      }

      /* ── 多 SKU 选择弹框（由 lottery-common-sku 组件承载） ── */

      /**
       * 唤起 lottery-common-sku 弹框。
       * 组件封装了 SKU 选择 + 内置领奖全流程：
       *   - trigger / confirm 按钮 loading
       *   - 商品拉取、SKU 渲染
       *   - updateClaimVariant 接口（路径硬编码）
       *   - 实物奖品 queryClaimParams → checkoutUrl 跳转
       *   - 非实物奖品成功后弹框关闭 + 发 :claimed
       * HTTP 工具（POST/GET + base URL + Authorization）由组件内部按
       * window.__MC__CONFIG__ 自实现，传入 prize + trigger 即可。
       * 监听 :claimed / :error 做 UI 反馈。
       */
      async _openVariantModal(prize, trigger, sourceModal) {
        // 记录触发本次 SKU 弹框的前置弹框（result / record），用于关闭时精准恢复
        // sourceModal 可不传；未传时回退到当前可见的弹框
        this._skuSourceModal =
          sourceModal ||
          (this._resultModal && this._resultModal._isOpen
            ? this._resultModal
            : this._recordModal && this._recordModal._isOpen
              ? this._recordModal
              : null);
        // 只隐藏触发源弹框（避免与中奖记录等其它无关弹框干扰）
        if (this._skuSourceModal) {
          this._setModalHidden(this._skuSourceModal, true);
        }
        document.dispatchEvent(
          new CustomEvent("autumn-sku:open", {
            detail: {
              prize: {
                productId:
                  aplPrizeProductId(
                    prize,
                    this._getPrizeMeta(prize).productId,
                  ) || "",
                productHandle: prize.productHandle || "",
                name: prize.name || "",
                image: prize.image || "",
                claimVariantId: prize.claimVariantId || "",
                // 内置领奖流程所需字段
                activityUserPrizeCode: prize.activityUserPrizeCode || "",
                activityType: this._activityType || "",
                prizeType: prize.prizeType,
                raw: prize.raw,
              },
              // HTTP 工具（POST/GET + base URL + Authorization）由组件内部按
              // window.__MC__CONFIG__ 自实现，无需消费者传递。
              trigger: trigger || null,
              source: "variant-action",
              // 透传透明遮罩背景：业务方已在 _setModalHidden 中保留了
              // 抽奖转盘的 wheel overlay（rgba(0,0,0,.15)），避免 SKU 自己
              // 再叠一层暗色遮罩造成"双重 dim"的效果
              background: "transparent",
              i18n: {
                title: this._t("switchSpecs"),
                cancel: this._t("cancel"),
                confirm: this._t("confirm"),
              },
            },
          }),
        );
      }

      /**
       * 临时隐藏/恢复指定的弹框（含其遮罩背景层）。
       * 用于打开 SKU 弹框时避免与触发源弹框叠层。
       *
       * 行为（按用户动画要求：150~250ms 跨弹框淡入淡出，纯净 opacity 过渡）：
       * - 隐藏时：用 .is-fading-out-by-sku 覆盖默认 transform（保持位置），
       *          让 .is-open 状态保留 → 仅 opacity 1→0 平滑过渡，
       *          过渡结束后才设 display:none（避免根因默认 transform 偏移造成的"缩"感）
       * - 恢复时：先清 display:none、强制 reflow，移除过渡类，
       *          再加 is-open 触发 opacity:0→1 过渡
       * - 遮罩共享：result / record 与 draw-wheel 共享同一遮罩；
       *   result 弹框特殊处理：保留遮罩可见但淡化（避免 wheel 上下文被打断）
       */
      _setModalHidden(modal, hidden) {
        if (!modal || !modal._boxEl) return;
        const box = modal._boxEl;
        const overlay = box.closest(".m26-modal-overlay");
        if (hidden) {
          if (modal._hiddenBySku) return; // 已隐藏，避免重复处理
          box.setAttribute("data-apl-hidden-by-sku", "1");
          box.setAttribute("aria-hidden", "true");
          modal._hiddenBySku = true;

          // 取消任何进行中的 show/close 动画计时器
          if (modal._switchTimer) {
            clearTimeout(modal._switchTimer);
            modal._switchTimer = null;
          }

          // 1) 仅添加淡出类（不 remove is-open，避免默认 transform 偏移）
          //    .is-fading-out-by-sku 用相同 transform 抵消位移，仅过渡 opacity
          box.classList.add("is-fading-out-by-sku");
          box.style.pointerEvents = "none";
          overlay.style.pointerEvents = "none";

          // 3) 等过渡结束（200ms，与 CSS transition-duration 对齐）
          modal._switchTimer = setTimeout(() => {
            modal._switchTimer = null;
            if (!modal._hiddenBySku) return; // 期间已被恢复，跳过
            // 4) 真正设 display:none + 清淡出类
            box.style.display = "none";
            box.classList.remove("is-fading-out-by-sku");
          }, 200);
        } else if (modal._hiddenBySku) {
          // 取消进行中的淡出计时器
          if (modal._switchTimer) {
            clearTimeout(modal._switchTimer);
            modal._switchTimer = null;
          }
          // 恢复流程（避免"瞬间显形"闪烁）：
          // 1) 先清 display:none，让 box 重新进入渲染树
          // 2) 加 .is-restoring-by-sku（强制 opacity:0，避免 is-open 直接到 1 造成闪烁）
          // 3) 移除淡出类与隐藏标记
          // 4) 强制 reflow
          // 5) 移除 .is-restoring-by-sku + 加 is-open，触发 opacity 0→1 过渡
          box.style.display = "";
          box.classList.remove("is-fading-out-by-sku");
          box.classList.add("is-restoring-by-sku");
          box.style.pointerEvents = "";
          box.removeAttribute("data-apl-hidden-by-sku");
          // 强制 reflow 让浏览器应用 display:"" + restoring 类的初始 opacity:0
          // eslint-disable-next-line no-unused-expressions
          box.offsetHeight;
          // 移除 restoring → 加 is-open（如果源弹框原本就处于 open 状态），
          // 触发 opacity:0→1 过渡（200ms）
          box.classList.remove("is-restoring-by-sku");
          if (modal._isOpen) {
            box.classList.add("is-open");
          }
          box.removeAttribute("aria-hidden");
          modal._hiddenBySku = false;
          overlay.style.pointerEvents = "";
          // 恢复遮罩（必须同时恢复 is-open 类，否则 CSS .m26-modal-overlay { opacity:0 }
          // 会让遮罩仍然不可见但仍然 pointer-events:auto，挡住页面点击）
        }
      }

      /**
       * lottery-common-sku 派发的 autumn-sku:claimed 通知（内置领奖流程成功）。
       * 非实物奖品（resultType='success'）：关闭其它弹框 + 弹成功 toast。
       * 实物奖品（resultType='redirect'）：页面即将跳转，无需 UI 反馈，仅做埋点。
       */
      _handleSkuClaimed(e) {
        const detail = (e && e.detail) || {};
        const resultType = detail.resultType;
        const prize = detail.prize;
        if (resultType === "redirect") {
          // 实物奖品即将 window.location.href = checkoutUrl，页面会销毁
          // 先主动关闭本组件关联的所有弹框，避免浏览器回退命中 bfcache
          // 时页面仍显示弹框（sku 弹框由组件内部自动 close，也兜底关一次）
          this._closeModal(this._resultModal);
          this._closeModal(this._recordModal);
          if (
            this._skuSourceModal &&
            this._skuSourceModal !== this._resultModal &&
            this._skuSourceModal !== this._recordModal
          ) {
            this._closeModal(this._skuSourceModal);
          }
          this._skuSourceModal = null;

          return;
        }
        // 非实物奖品：先恢复（避免视觉上"弹框闪一下再关"） -> 再关闭其它业务弹框 -> 成功 toast
        const src = this._skuSourceModal;
        if (src && src._hiddenBySku) this._setModalHidden(src, false);
        // 同时关闭另一个非源业务弹框（如 _recordModal 开着则一并关）
        if (src !== this._resultModal) this._closeModal(this._resultModal);
        if (src !== this._recordModal) this._closeModal(this._recordModal);
        if (src) this._closeModal(src);
        this._skuSourceModal = null;
        this._showToast(
          aplApiMessage(prize && prize.raw) || this._t("claimSuccess"),
          "success",
        );
      }

      /**
       * lottery-common-sku 派发的 autumn-sku:close 通知（cancel/overlay/escape 路径）。
       * 只恢复触发源弹框 + 刷新抽奖锁状态；按钮 loading 由组件自行收尾。
       */
      _handleSkuClose() {
        const src = this._skuSourceModal;
        if (src && src._hiddenBySku) this._setModalHidden(src, false);
        this._skuSourceModal = null;
        // 等待弹框淡出动画结束后再刷新锁状态
        setTimeout(() => this._applyDrawWheelCloseState(), 360);
      }

      /**
       * lottery-common-sku 派发的 autumn-sku:error 通知。
       * 仅做错误提示；按钮 loading 与弹框状态由组件自行管理。
       */
      _handleSkuError(e) {
        const err = e && e.detail && e.detail.error;
        this._showToast(aplApiMessage(err) || this._t("claimFailed"), "error");
      }

      _setButtonLoading(button, loading) {
        if (!button) return;
        button.classList.toggle("is-loading", !!loading);
        button.disabled = !!loading;
        button.setAttribute("aria-busy", loading ? "true" : "false");
      }

      _closeModal(modal) {
        if (modal && typeof modal.close === "function") modal.close();
        setTimeout(() => this._applyDrawWheelCloseState(), 360);
      }

      _showToast(message, type) {
        const icon =
          type === "error"
            ? this.dataset.toastErrorIcon
            : this.dataset.toastSuccessIcon;
        let toast = document.querySelector(".apl-toast");
        if (!toast) {
          toast = document.createElement("div");
          toast.className = "apl-toast";
          toast.innerHTML =
            '<span class="apl-toast__icon" data-apl-toast-icon></span><span class="apl-toast__content" data-apl-toast-content></span>';
          document.body.appendChild(toast);
        }
        toast.classList.toggle("apl-toast--error", type === "error");
        const iconEl = toast.querySelector("[data-apl-toast-icon]");
        const contentEl = toast.querySelector("[data-apl-toast-content]");
        if (iconEl) {
          iconEl.innerHTML = icon
            ? `<img src="${this._esc(icon)}" alt="">`
            : type === "error"
              ? "!"
              : "✓";
        }
        if (contentEl) contentEl.textContent = message || "";
        toast.classList.add("is-visible");
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(
          () => toast.classList.remove("is-visible"),
          1500,
        );
      }

      async _fetchWinningRecords() {
        return aplApiGet(
          "/api/station/activity/raffle/queryShopWinningRecord",
          {
            activityType: this._activityType || "",
            newRaffleFlow: true,
          },
        );
      }

      _currentUserEmail() {
        aplSyncM26AuthFromCookie();
        const auth = aplGetM26Auth();
        return (
          (auth && auth.user && auth.user.email) ||
          (window.__MOMCOZY_USER_INFO__ &&
            window.__MOMCOZY_USER_INFO__.email) ||
          ""
        );
      }

      _formatRecordTime(value) {
        if (value === null || value === undefined || value === "") return "";
        let ts = typeof value === "number" ? value : Number(value);
        if (!Number.isFinite(ts)) return String(value);
        if (ts < 1e12) ts *= 1000;
        try {
          const marketMap = {
            us: "America/New_York",
            ca: "America/Toronto",
            uk: "Europe/London",
            de: "Europe/Berlin",
            fr: "Europe/Paris",
            es: "Europe/Madrid",
            pl: "Europe/Warsaw",
            au: "Australia/Sydney",
            nz: "Pacific/Auckland",
          };
          const market =
            (window.__MC__CONFIG__ && window.__MC__CONFIG__.market) || "";
          const parts = new Intl.DateTimeFormat("en-US", {
            timeZone: marketMap[String(market).toLowerCase()] || undefined,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          }).formatToParts(new Date(ts));
          const map = {};
          parts.forEach((part) => {
            map[part.type] = part.value;
          });
          let hour = Number(map.hour || 0);
          if (hour === 24) hour = 0;
          const period = hour >= 12 ? this._t("pm") : this._t("am");
          const hour12 = hour % 12 || 12;
          return `${map.month}/${map.day}/${map.year} ${hour12}:${map.minute || "00"}:${map.second || "00"} ${period}`;
        } catch (_) {
          return "";
        }
      }

      _normalizeRecord(raw) {
        const item = raw && typeof raw === "object" ? raw : {};
        const prize = this._normalizePrize(item);
        prize.raw = item;
        prize.prizeType = Number(
          item.prizeType || item.type || prize.prizeType || 0,
        );
        prize.needSelectVariant = aplTruthy(
          item.needSelectVariant == null
            ? item.multiVariant
            : item.needSelectVariant,
        );
        prize.activityUserPrizeCode =
          item.activityUserPrizeCode ||
          item.userPrizeCode ||
          item.prizeCode ||
          prize.activityUserPrizeCode ||
          "";
        prize.claimVariantId = aplNormalizeId(
          item.claimVariantId ||
            item.variantId ||
            item.defaultVariantId ||
            prize.claimVariantId,
        );
        prize.productId = aplPrizeProductId(item, prize.productId);
        prize.productHandle =
          item.productHandle || item.handle || prize.productHandle || "";
        prize.name = item.prizeName || item.name || prize.name || "";
        prize.image = item.prizeImg || item.prizeUrl || prize.image || "";
        prize.claimStatus = Number(item.claimStatus || 0);
        prize.claimStatusDesc = item.claimStatusDesc || "";
        prize.claimVariantTitle = item.claimVariantTitle || "";
        prize.claimOrderName = item.claimOrderName || "";
        prize.prizeTimeText = this._formatRecordTime(
          item.prizeTime || item.createTime || item.createdAt,
        );
        return prize;
      }

      _renderRecordModal(records, state) {
        const sid = this._esc(this.dataset.sectionId || "");
        const email = this._currentUserEmail();
        let listHtml = "";
        if (state === "loading") {
          listHtml = this._renderRecordSkeleton();
        } else if (!records || !records.length) {
          const emptyIcon = this.dataset.recordEmptyIcon || "";
          listHtml = `<div class="apl-record__state">${emptyIcon ? `<img class="apl-record__state-icon" src="${this._esc(emptyIcon)}" alt="" loading="lazy">` : ""}<p>${this._esc(this._t("noWinningRecords"))}</p></div>`;
        } else {
          listHtml = records
            .map((item, index) => this._renderRecordItem(item, index, sid))
            .join("");
        }
        return `<div class="apl-record"><h2 class="apl-record__title">${this._esc(this._t("recordTitle"))}</h2>${email ? `<p class="apl-record__email">(${this._esc(email)})</p>` : ""}<div class="apl-record__list">${listHtml}</div></div>`;
      }

      _renderRecordSkeleton() {
        // 移动端默认渲染 2 个骨架项，减少与空状态之间的高度差，避免弹框"跳动"
        const isMobile = window.innerWidth <= 768;
        const skeletonCount = isMobile ? 2 : 3;
        return Array.from({ length: skeletonCount })
          .map(
            () =>
              `<div class="apl-record__item apl-record__item--skeleton" aria-hidden="true"><div class="apl-record__media"><span class="apl-record__skeleton apl-record__skeleton-img"></span></div><div class="apl-record__info"><span class="apl-record__skeleton apl-record__skeleton-title"></span><span class="apl-record__skeleton apl-record__skeleton-text"></span></div><div class="apl-record__status"><span class="apl-record__skeleton apl-record__skeleton-text"></span><span class="apl-record__skeleton apl-record__skeleton-short"></span></div><div class="apl-record__ops"><span class="apl-record__skeleton apl-record__skeleton-action"></span></div></div>`,
          )
          .join("");
      }

      _renderRecordItem(item, index, sid) {
        const isMobile = window.innerWidth <= 768;
        const canEdit =
          item.prizeType === 1 &&
          item.needSelectVariant &&
          item.claimStatus === 10;
        const variantHtml = item.claimVariantTitle
          ? `<div class="apl-record__variant"><span>${this._esc(item.claimVariantTitle)}</span>${canEdit ? `<button type="button" class="apl-record__link apl-record__edit" data-apl-section="${sid}" data-apl-record-action="edit" data-apl-record-index="${index}">${this._esc(this._t("edit"))}</button>` : ""}</div>`
          : canEdit
            ? `<div class="apl-record__variant"><button type="button" class="apl-record__link apl-record__edit" data-apl-section="${sid}" data-apl-record-action="edit" data-apl-record-index="${index}">${this._esc(this._t("edit"))}</button></div>`
            : "";
        const statusHtml =
          item.claimStatusDesc || variantHtml
            ? `${item.claimStatusDesc ? `<p>${this._esc(item.claimStatusDesc)}</p>` : ""}${variantHtml}`
            : isMobile
              ? ""
              : `<p>-</p>`;
        let action = "-";
        if (item.claimStatus === 10) {
          //此处需要进行区分处理
          action = `<button type="button" class="apl-record__link apl-record__action" data-apl-section="${sid}" data-apl-record-action="claim" data-apl-record-index="${index}">${this._esc(this._t("claim"))}</button>`;
          action = this._renderActionByDefault(item, sid, index, action);
        } else if (item.claimStatus === 20) {
          action = `<button type="button" class="apl-record__link apl-record__action is-disabled" disabled>${this._esc(this._t("claimed"))}</button>`;
          action = this._renderActionByDefault(item, sid, index, action);
        } else if (item.claimStatus === 30) {
          action = `<button type="button" class="apl-record__link apl-record__action" data-apl-section="${sid}" data-apl-record-action="contact" data-apl-record-index="${index}">${this._t("contactMomcozy")}</button>`;
        }
        const orderHtml =
          item.prizeType === 1 && item.claimStatus === 20
            ? `<p>${this._esc(this._t("recordOrderName"))}: ${this._esc(item.claimOrderName)}</p>`
            : "";
        return `<div class="apl-record__item"><div class="apl-record__media">${item.image ? `<img src="${this._esc(item.image)}" alt="${this._esc(item.name)}" loading="lazy">` : ""}</div><div class="apl-record__info"><h3>${this._esc(item.name)}</h3>${item.prizeTimeText ? `<p>${this._esc(item.prizeTimeText)}</p>` : ""}</div><div class="apl-record__status">${statusHtml}${orderHtml}</div><div class="apl-record__ops">${action}</div></div>`;
      }

      _renderActionByDefault(item, sid, index, defaultAction) {
        const { prizeType, couponCode } = item;
        const accountBase = aplAccountBase();
        let action = defaultAction;
        if (prizeType === 2) {
          //如果是积分类型则跳转到会员中心积分页面
          action = `<a href="${accountBase}/coins" class="apl-record__link apl-record__action">${this._t("goToMemberCenter")}</a>`;
        } else if ([3, 7].includes(prizeType)) {
          //如果是优惠券类型则显示优惠券吗和复制按钮
          action = `<div class="apl-record__action__container"><span>${couponCode}</span><button type="button" class="apl-record__link apl-record__action" data-apl-section="${sid}" data-apl-record-action="copy" data-apl-record-index="${index}">${this._esc(this._t("copy"))}</button></div>`;
        } else if (prizeType === 5) {
          //如果是礼品卡类型则跳转到会员中心礼品卡页面
          action = `<a href="${accountBase}/coupon" class="apl-record__link apl-record__action">${this._t("goToGiftCardCenter")}</a>`;
        }
        return action;
      }

      async _openRecordModal() {
        aplSyncM26AuthFromCookie();
        const auth = aplGetM26Auth();
        if (!auth || !auth.user) {
          this._aplLogin();
          return;
        }
        if (!M26ModalLocal) return;
        if (!this._recordModal) {
          this._recordModal = new M26ModalLocal("apl-modal apl-modal--record");
        }
        const recordBtn = this.querySelector("[data-apl-record]");
        this._recordModal.setContent(this._renderRecordModal([], "loading"));
        this._recordModal.show();
        if (recordBtn) recordBtn.setAttribute("aria-expanded", "true");
        setTimeout(() => {
          if (recordBtn) recordBtn.setAttribute("aria-expanded", "false");
        }, 400);
        try {
          const res = await this._fetchWinningRecords();
          const records = Array.isArray(res.recordBeans) ? res.recordBeans : [];
          this._recordItems = records.map((item) =>
            this._normalizeRecord(item),
          );
          this._recordModal.setContent(
            this._renderRecordModal(this._recordItems),
          );
        } catch (err) {
          this._recordItems = [];
          this._recordModal.setContent(this._renderRecordModal([], "empty"));
          this._showToast(
            aplApiMessage(err) || this._t("requestFailed"),
            "error",
          );
        }
      }

      async _handleRecordAction(button) {
        const action = button.dataset.aplRecordAction;
        const index = Number(button.dataset.aplRecordIndex);
        const prize = this._recordItems[index];
        if (!prize) return;
        if (action === "contact") {
          const launcher = document.querySelector("#launcher");
          if (launcher) launcher.style.zIndex = "1999";
          if (typeof window.zE === "function") window.zE("messenger", "open");
          return;
        }
        if (action === "edit") {
          this._openVariantModal(prize, button, this._recordModal);
          return;
        }
        if (action === "claim") {
          this._closeModal(this._recordModal);
          await this._claimPrize(prize, button);
        }
        if (action === "copy") {
          this._copyCoupon(prize.couponCode, button);
          return;
        }
      }

      _esc(str) {
        if (str == null) return "";
        return String(str)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      }

      /* ── 登录成功后刷新页面，滚动到本组件可视区 ── */
      _checkHashScroll() {
        const sid = this.dataset.sectionId || "";
        const expectedHash = "apl-" + sid;
        const hash = window.location.hash.slice(1);
        if (hash !== expectedHash) return;
        history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search,
        );
        setTimeout(() => {
          M26LotteryLocal.scrollToEl(this);
        }, 300);
      }

      /* ── 本组件专用登录唤起，redirect 带 hash 标记 ── */
      _aplLogin() {
        const sid = this.dataset.sectionId || "";
        const url = new URL(window.location.href);
        url.hash = "apl-" + sid;
        const options = {
          activityType: `${this.dataset.registerSource || this._activityType || window.__APL_ACTIVITY_TYPE__ || ""}`,
          mustAgreeEmail: true,
          redirect: url.toString(),
        };
        let didOpen = false;
        const syncDialogContext = (dialogEl) => {
          try {
            dialogEl.setAttribute("activity-type", options.activityType);
            dialogEl.setAttribute("redirect", options.redirect);
            dialogEl.setAttribute("must-agree-email", "");
          } catch (e) {}
          try {
            dialogEl.activityType = options.activityType;
          } catch (e) {}
          try {
            dialogEl.activitytype = options.activityType;
          } catch (e) {}
          try {
            dialogEl.redirect = options.redirect;
          } catch (e) {}
          try {
            dialogEl.mustAgreeEmail = true;
          } catch (e) {}
          try {
            dialogEl.dispatchEvent(
              new CustomEvent("register-source-changed", {
                bubbles: true,
                detail: { value: options.activityType, source: "apl" },
              }),
            );
          } catch (e) {}
          try {
            let input = dialogEl.querySelector(
              'input[name="activity_type"], input[name="activityType"]',
            );
            if (!input) {
              input = document.createElement("input");
              input.type = "hidden";
              input.name = "activity_type";
              input.dataset.aplInjected = "true";
              dialogEl.appendChild(input);
            }
            input.value = options.activityType;
          } catch (e) {}
        };
        const openDialog = () => {
          if (didOpen) return;
          const loginDialog = document.querySelector("login-dialog");
          if (!loginDialog) {
            if (m26LoginLocal) m26LoginLocal();
            return;
          }
          syncDialogContext(loginDialog);
          const quickRegisterDialog = document.querySelector(
            "quick-register-member-dialog",
          );
          if (quickRegisterDialog) syncDialogContext(quickRegisterDialog);
          if (typeof loginDialog.open === "function") {
            loginDialog.open();
            didOpen = true;
          } else if (typeof loginDialog.click === "function") {
            loginDialog.click();
          }
        };
        openDialog();
        if (
          window.customElements &&
          typeof window.customElements.whenDefined === "function"
        ) {
          window.customElements
            .whenDefined("login-dialog")
            .then(openDialog)
            .catch(() => {});
        }
      }
    }
    customElements.define("apl-app", AplApp);
  }
})();
